module.exports = __webpack_public_path__ + "VG.png?6899896d5730dcb27e407e112df54e3a";